import { createSlice } from "@reduxjs/toolkit";

let initialStateForProfile = {
  isUserLogIn: false,
  userId: null,
  userRole: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState: initialStateForProfile,
  reducers: {
    setProfile(state, action) {
      console.log("action.payload :: ", action.payload);
      return action.payload;
    },
  },
});

export const { setProfile } = profileSlice.actions;
export default profileSlice.reducer;
